import { CommonModule } from '@angular/common';
import { Component, OnInit, computed, input, model } from '@angular/core';
import { BaseConfig } from '@client';
import { TranslatePipe } from '@ngx-translate/core';

export type SegmentOption = {
  label: string;
  value: string;
  count?: number;
};

@Component({
  selector: 'app-segment-tap',
  templateUrl: './segment-tap.component.html',
  styleUrls: ['./segment-tap.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslatePipe],
})
export class SegmentTap extends BaseConfig implements OnInit {
  value = model<string>('');
  $options = input<string[] | SegmentOption[]>([], { alias: 'options' });
  gapOption = input<string>('gap-8');
  optionActiveStyle = input<string>('text-white');
  optionStyle = input<string>('text-zinc-500');
  paddingStyle = input<string>('');

  options = computed<SegmentOption[]>(() => {
    if (this.$options().length === 0) return [];

    return this.$options().map((option) => {
      if (typeof option === 'string') {
        return {
          label: option,
          value: option,
          count: option.length,
        };
      }

      return option;
    });
  });

  constructor() {
    super();
  }

  ngOnInit() {
    if (!this.value()) {
      this.value.set(this.options()[0].value);
    }
  }

  handleClick(option: SegmentOption) {
    this.value.set(option.value);
  }
}
